define('js/actions',['require','exports','module','cloud-api'],function(require, exports, module) {
    'use strict';
    var cloudApi = require('cloud-api');
    var actionId = 'marketingPromo';

    var getFeatureAction = new Promise(function(resolve) {
        cloudApi
            .then(function(_cloudApi) {
                var cloudApi = _cloudApi || window.__cloudApi__;
                // для текущей акции не нужны промо на лп
                // var isFeatureAction = cloudApi && cloudApi.features.isFeature(actionId);
                var isFeatureAction = false;

                resolve(isFeatureAction);
            });
    });

    module.exports = {
        actionId: actionId,
        getFeatureAction: getFeatureAction
    };
});

